// @flow
import * as React from 'react';

type Props = {
  show: boolean;
  children: React.ReactNode;
};
export const Condition = ({show, children}: Props) => {
  return show ? <>{children}</> : <> </>;
};